import * as React from 'react'
import PropTypes from 'prop-types'

import { DASHBOARD_URL, HELP_URL } from '../../../models/Eventplanner'

import { DesktopMenu, RequestsUnreadCountWrapper, ButtonInnerContent } from './style'

import HeaderMenuItemUserDesktop from '../../header-menu-item-user-desktop'
import HeaderMenuList from '../../../ui/header-menu-list'
import HeaderMenuItem from '../../../ui/header-menu-list-item'
import HeaderMenuButton from '../../../ui/header-menu-button'
import { SearchIcon } from '../../../icons'
import GigRequestUnreadCount from '../../gig-request-unread-count'

const EvenplannerDektopMenu = () => (
  <DesktopMenu>
    <HeaderMenuList>
      <HeaderMenuItem>
        <HeaderMenuButton to="/s" title="Gå til søk" aria-label="Gå til søk">
          <SearchIcon height={30} width={30} />
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItem>
        <HeaderMenuButton
          to={DASHBOARD_URL}
          title="Gå til forespørsler"
          aria-label="Gå til forespørsler"
        >
          <ButtonInnerContent>
            Forespørsler
            <RequestsUnreadCountWrapper>
              <GigRequestUnreadCount forEventplanner />
            </RequestsUnreadCountWrapper>
          </ButtonInnerContent>
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItem>
        <HeaderMenuButton to={HELP_URL} title="Gå til hjelp" aria-label="Gå til hjelp">
          Hjelp
        </HeaderMenuButton>
      </HeaderMenuItem>
      <HeaderMenuItemUserDesktop showEventplannerMenu />
    </HeaderMenuList>
  </DesktopMenu>
)

EvenplannerDektopMenu.propTypes = {}
EvenplannerDektopMenu.defaultProps = {}

export default EvenplannerDektopMenu
